import React, { useCallback } from 'react';
import { Layout, message } from 'antd';
import { Content } from 'common/StyledComponents';
import {
  BusinessPartnerForm,
  BusinessPartnerFormModel,
} from 'pages/BusinessPartnerManagement/BusinessPartnerForm';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { FormikOnSubmit } from 'lib/formik.utils';
import { QueryKey } from 'api/queryKey';
import { useHistory } from 'react-router';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { businessPartnerManagementRoutes } from 'pages/SuperAdminModule/BusinessPartnersManagement/businessPartnerManagementRoutes';

const NewBusinessPartnerPage = () => {
  const queryCache = useQueryCache();
  const [mutate, { isLoading }] = useMutation(BusinessPartnersAPI.create);
  const history = useHistory();
  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<BusinessPartnerFormModel> = useCallback(
    (formData, { resetForm }) => {
      mutate(formData, {
        onSuccess: () => {
          resetForm();
          queryCache.invalidateQueries(QueryKey.BusinessPartnersList).then();
          message.success(
            intlMessage(
              { id: 'businessPartners.addNew.success' },
              { name: formData.name }
            )
          );
          history.push(`./${businessPartnerManagementRoutes.List}`);
        },
      }).then();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mutate, queryCache]
  );

  return (
    <Layout>
      <Content>
        <BusinessPartnerForm onSubmit={handleSubmit} loading={isLoading} />
      </Content>
    </Layout>
  );
};

// eslint-disable-next-line import/no-default-export
export default NewBusinessPartnerPage;
